var simplemaps_countrymap_mapdata = {
    main_settings: {
        //General settings
        width: "300", //or 'responsive'
        background_color: "#FFFFFF",
        background_transparent: "yes",
        border_color: "#ffffff",
        pop_ups: "detect",

        //State defaults
        state_description: "State description",
        state_color: "#88A4BC",
        state_hover_color: "#3B729F",
        state_url: "",
        border_size: 1.5,
        all_states_inactive: "no",
        all_states_zoomable: "yes",

        //Location defaults
        location_description: "Location description",
        location_url: "",
        location_color: "#FF0067",
        location_opacity: 0.8,
        location_hover_opacity: 1,
        location_size: 25,
        location_type: "square",
        location_image_source: "frog.png",
        location_border_color: "#FFFFFF",
        location_border: 2,
        location_hover_border: 2.5,
        all_locations_inactive: "no",
        all_locations_hidden: "no",

        //Label defaults
        label_color: "#d5ddec",
        label_hover_color: "#d5ddec",
        label_size: 22,
        label_font: "Arial",
        hide_labels: "no",
        hide_eastern_labels: "no",

        //Zoom settings
        zoom: "yes",
        manual_zoom: "yes",
        back_image: "no",
        initial_back: "no",
        initial_zoom: "-1",
        initial_zoom_solo: "no",
        region_opacity: 1,
        region_hover_opacity: 0.6,
        zoom_out_incrementally: "yes",
        zoom_percentage: 0.99,
        zoom_time: 0.5,

        //Popup settings
        popup_color: "white",
        popup_opacity: 0.9,
        popup_shadow: 1,
        popup_corners: 5,
        popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
        popup_nocss: "no",

        //Advanced settings
        div: "map",
        auto_load: "yes",
        url_new_tab: "no",
        images_directory: "default",
        fade_time: 0.1,
        link_text: "View Website",
    },
    state_specific: {
        THA374: {
            name: "Mae Hong Son",
            description: "default",
            color: "default",
            hover_color: "default",
            url: "default",
        },
        THA375: {
            name: "Chumphon",
        },
        THA376: {
            name: "Nakhon Si Thammarat",
        },
        THA377: {
            name: "Phuket",
        },
        THA378: {
            name: "Phangnga",
        },
        THA379: {
            name: "Ranong",
        },
        THA380: {
            name: "Surat Thani",
        },
        THA382: {
            name: "Krabi",
        },
        THA383: {
            name: "Phatthalung",
        },
        THA385: {
            name: "Satun",
        },
        THA386: {
            name: "Songkhla",
        },
        THA387: {
            name: "Trang",
        },
        THA388: {
            name: "Yala",
        },
        THA389: {
            name: "Chiang Rai",
        },
        THA390: {
            name: "Chiang Mai",
        },
        THA391: {
            name: "Lampang",
        },
        THA392: {
            name: "Lamphun",
        },
        THA393: {
            name: "Nan",
        },
        THA394: {
            name: "Phayao",
        },
        THA395: {
            name: "Phrae",
        },
        THA396: {
            name: "Phitsanulok",
        },
        THA397: {
            name: "Sukhothai",
        },
        THA398: {
            name: "Uttaradit",
        },
        THA399: {
            name: "Kanchanaburi",
        },
        THA400: {
            name: "Kamphaeng Phet",
        },
        THA401: {
            name: "Phichit",
        },
        THA402: {
            name: "Phetchabun",
        },
        THA403: {
            name: "Suphan Buri",
        },
        THA404: {
            name: "Tak",
        },
        THA405: {
            name: "Uthai Thani",
        },
        THA406: {
            name: "Ang Thong",
        },
        THA407: {
            name: "Chai Nat",
        },
        THA408: {
            name: "Lop Buri",
        },
        THA409: {
            name: "Nakhon Nayok",
        },
        THA410: {
            name: "Prachin Buri",
        },
        THA411: {
            name: "Nakhon Sawan",
        },
        THA412: {
            name: "Phra Nakhon Si Ayutthaya",
        },
        THA413: {
            name: "Pathum Thani",
        },
        THA414: {
            name: "Sing Buri",
        },
        THA415: {
            name: "Saraburi",
        },
        THA416: {
            name: "Bangkok Metropolis",
        },
        THA417: {
            name: "Nonthaburi",
        },
        THA418: {
            name: "Nakhon Pathom",
        },
        THA419: {
            name: "Phetchaburi",
        },
        THA420: {
            name: "Prachuap Khiri Khan",
        },
        THA421: {
            name: "Ratchaburi",
        },
        THA422: {
            name: "Samut Prakan",
        },
        THA423: {
            name: "Samut Sakhon",
        },
        THA424: {
            name: "Samut Songkhram",
        },
        THA425: {
            name: "Si Sa Ket",
        },
        THA426: {
            name: "Ubon Ratchathani",
        },
        THA427: {
            name: "Amnat Charoen",
        },
        THA428: {
            name: "Yasothon",
        },
        THA430: {
            name: "Chon Buri",
        },
        THA431: {
            name: "Chachoengsao",
        },
        THA432: {
            name: "Chanthaburi",
        },
        THA433: {
            name: "Sa Kaeo",
        },
        THA434: {
            name: "Rayong",
        },
        THA435: {
            name: "Trat",
        },
        THA436: {
            name: "Buri Ram",
        },
        THA437: {
            name: "Chaiyaphum",
        },
        THA438: {
            name: "Khon Kaen",
        },
        THA439: {
            name: "Kalasin",
        },
        THA440: {
            name: "Maha Sarakham",
        },
        THA441: {
            name: "Nakhon Ratchasima",
        },
        THA442: {
            name: "Roi Et",
        },
        THA443: {
            name: "Surin",
        },
        THA445: {
            name: "Loei",
        },
        THA446: {
            name: "Nong Khai",
        },
        THA447: {
            name: "Sakon Nakhon",
        },
        THA448: {
            name: "Udon Thani",
        },
        THA449: {
            name: "Nong Bua Lam Phu",
        },
        THA472: {
            name: "Nakhon Phanom",
        },
        THA473: {
            name: "Mukdahan",
        },
        THA493: {
            name: "Narathiwat",
        },
        THA494: {
            name: "Pattani",
        },
        THA5499: {
            name: "Bueng Kan",
        },
    },
    locations: {
        "0": {
            lat: "13.753979",
            lng: "100.501444",
            name: "Bangkok",
        },
    },
}